import React, { useState, useEffect } from 'react';
import { applicationService } from '../../services/api';
import { getUserData } from '../../utils/auth';
import './CoordinatorApplications.css';

function CoordinatorApplications() {
  const userData = getUserData();
  const collegeId = userData?.collegeId || userData?.CollegeId;

  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    if (collegeId) loadData();
    else setLoading(false);
  }, [collegeId]);

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await applicationService.getApplicationsByCollege(collegeId);
      setApplications(data || []);
    } catch (error) {
      alert('Error loading applications: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : '-');
  const formatFileName = (path) => (path ? path.split(/[/\\]/).pop() : '-');

  if (!collegeId) return <div className="coord-apps"><p>College session not found.</p></div>;

  return (
    <div className="coord-apps">
      <div className="page-header">
        <h1>Applications (College)</h1>
        <p>View applications for vacancies in your college. Shortlisting is done by companies.</p>
      </div>

      {loading ? <p>Loading applications...</p> : (
        <div className="applications-list">
          {applications.length === 0 ? (
            <p className="no-data">No applications yet.</p>
          ) : (
            applications.map((a) => (
              <div key={a.Id} className="app-card">
                <div className="app-row" onClick={() => setExpandedId(expandedId === a.Id ? null : a.Id)}>
                  <div className="app-info">
                    <strong>{a.Student?.Name}</strong> ({a.Student?.Code}) – {a.Vacancy?.Title}
                  </div>
                  <span className={`status-badge ${a.IsShortlisted ? 'yes' : 'no'}`}>
                    {a.IsShortlisted ? 'Shortlisted by Company' : 'Pending'}
                  </span>
                </div>
                {expandedId === a.Id && (
                  <div className="app-details">
                    <p><strong>Email:</strong> {a.Student?.Email}</p>
                    <p><strong>Mobile:</strong> {a.Student?.MobileNo}</p>
                    <p><strong>Vacancy:</strong> {a.Vacancy?.Title}</p>
                    <p><strong>Company:</strong> {a.Vacancy?.Company?.Name}</p>
                    <p><strong>Date:</strong> {formatDate(a.Date)}</p>
                    {a.Resume && (
                      <p>
                        <strong>Resume:</strong> {formatFileName(a.Resume)}
                        <button type="button" className="btn-download" onClick={() => applicationService.downloadResume(a.Id, formatFileName(a.Resume))}>
                          Download PDF
                        </button>
                      </p>
                    )}
                    {a.Description && <p><strong>Description:</strong> {a.Description}</p>}
                    {a.Answer1 && <p><strong>Answer 1:</strong> {a.Answer1}</p>}
                    {a.Answer2 && <p><strong>Answer 2:</strong> {a.Answer2}</p>}
                    {a.Answer3 && <p><strong>Answer 3:</strong> {a.Answer3}</p>}
                    {a.CompanyNotes && <p className="notes"><strong>Company Notes:</strong> {a.CompanyNotes}</p>}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default CoordinatorApplications;
